module.exports = __webpack_public_path__ + "img/9788959524846.49880475.jpg";